import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Navbar } from "./components/portfolio/Navbar";
import { WorkPaths } from "./components/portfolio/WorkPaths";
import { HeroSection } from "./components/portfolio/HeroSection";
import { MarqueeStrip } from "./components/portfolio/MarqueeStrip";
import { IntroStats } from "./components/portfolio/IntroStats";
import { ServicesGrid } from "./components/portfolio/ServicesGrid";
import { FeaturedWork } from "./components/portfolio/FeaturedWork";
import { ExperienceTimeline } from "./components/portfolio/ExperienceTimeline";
import { EntrepreneurshipSection } from "./components/portfolio/EntrepreneurshipSection";
import { TechStackSection } from "./components/portfolio/TechStackSection";
import { CaseStudiesSection } from "./components/portfolio/CaseStudiesSection";
import { FreelanceCTA } from "./components/portfolio/FreelanceCTA";
import { CollaborationsSection } from "./components/portfolio/CollaborationsSection";
import { AboutSection } from "./components/portfolio/AboutSection";
import { ContactSection } from "./components/portfolio/ContactSection";
import { Footer } from "./components/portfolio/Footer";

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#07090E] text-slate-100 font-body antialiased" data-testid="app-root">
      <Navbar />
      <main>
        <HeroSection />
        <MarqueeStrip />
        <IntroStats />
        <WorkPaths />
        <ServicesGrid />
        <FeaturedWork />
        <ExperienceTimeline />
        <EntrepreneurshipSection />
        <TechStackSection />
        <CaseStudiesSection />
        <FreelanceCTA />
        <CollaborationsSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#0F1420", border: "1px solid rgba(255,255,255,0.1)", color: "#F8FAFC" } }} />
    </div>
  );
}

export default App;
